import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useMemo } from 'react';
import { keyframes, css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { utilStyles } from '@paypalcorp/pp-react-utils';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    console.warn('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysColorPrimaryMain = tokens.sysColorPrimaryMain,
      sysColorPrimaryContrast = tokens.sysColorPrimaryContrast,
      sysSizeCircleXs = tokens.sysSizeCircleXs,
      sysSizeCircleSm = tokens.sysSizeCircleSm,
      sysSizeCircleMd = tokens.sysSizeCircleMd,
      sysSizeCircleXl = tokens.sysSizeCircleXl,
      sysBorderThicknessEmphasis = tokens.sysBorderThicknessEmphasis;
  var borderSpinner = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    to {\n      transform: rotate(360deg);\n    }\n  "])));

  var _utilStyles = utilStyles(tokens),
      screenReader = _utilStyles.screenReader;

  var base = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: loading-spinner_base;\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    animation: ", " 1s linear infinite;\n    border: ", " solid currentColor;\n    border-radius: 50%;\n    clip-path: polygon(50% 0%, 50% 50%, 100% 50%, 100% 100%, 0 100%, 0 0);\n  "])), sysSizeCircleXs, sysSizeCircleXs, sysColorPrimaryMain, borderSpinner, sysBorderThicknessEmphasis); // Size Xs

  var sizeXs = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    label: size_xs;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeCircleXs, sysSizeCircleXs); // Size md

  var sizeMd = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    label: size_md;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeCircleSm, sysSizeCircleSm); // Size Lg

  var sizeLg = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    label: size_lg;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeCircleMd, sysSizeCircleMd); // Size Xl

  var sizeXl = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    label: size_xl;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeCircleXl, sysSizeCircleXl); //  Inverse

  var inverse = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    label: inverse;\n    color: ", ";\n  "])), sysColorPrimaryContrast);
  return {
    base: base,
    sizeXs: sizeXs,
    sizeMd: sizeMd,
    sizeLg: sizeLg,
    sizeXl: sizeXl,
    inverse: inverse,
    screenReader: screenReader
  };
}

var _excluded = ["as", "className", "inverse", "size", "screenReaderText"];

var LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'p' : _ref$as,
      className = _ref.className,
      inverse = _ref.inverse,
      size = _ref.size,
      screenReaderText = _ref.screenReaderText,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  var sizesStyleMap = {
    xs: _styles.sizeXs,
    // to be used for stateful buttons ONLY.
    sm: '',
    md: _styles.sizeMd,
    lg: _styles.sizeLg,
    xl: _styles.sizeXl
  };
  var cssVal = [_styles.base, inverse && _styles.inverse, sizesStyleMap[size]];
  return jsx(as, _extends({
    css: cssVal,
    className: className,
    "data-ppui-info": "loading-spinner_3.1.19"
  }, rest, {
    role: "alert"
  }), jsx("span", {
    css: _styles.screenReader,
    "data-ppui": "true"
  }, screenReaderText));
};

export { LoadingSpinner, styles as loadingSpinnerStyles };